<script>
import { mapState } from 'vuex';

export default {
    name: "bonus",
    data() {
        return {
        };
    },
    computed: {
        ...mapState(['employeeData'])
    },
    components: {
        
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {},
};
</script>

<template>
    <div class="bonus">
        <template v-for="(item, index) in employeeData.benefit">
            <a class="item" v-if="item.link" :href="item.link" target="_blank">
                <div class="cover" :style="`background-image: url(${item.image});`"></div>
                <div class="text">
                    <div class="name">{{ item.name }}</div>
                    <div class="desc">{{ item.desc }}</div>
                </div>
            </a>
            <div class="item" v-else>
                <div class="cover" :style="`background-image: url(${item.image});`"></div>
                <div class="text">
                    <div class="name">{{ item.name }}</div>
                    <div class="desc">{{ item.desc }}</div>
                </div>
            </div>
        </template>
    </div>
</template>

<style scoped lang="scss">
.bonus{
    display: flex;
    gap: .16rem;
    flex-wrap: wrap;
    .item{
        width: 5.92rem;
        display: block;
        position: relative;
        .cover{
            padding-bottom: 72.8%;
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center;
            border-radius: .05rem;
        }
        .text{
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            gap: .2rem;
            color: #fff;
            text-shadow: 0 0 .1rem rgba($color: #000, $alpha: .5);
            .name{
                font-size: .36rem;
            }
            .desc{
                font-size: .18rem;
            }
        }
    }
    @media only screen and (max-width: 750px) {
        flex-direction: column;
        gap: .2rem;
        .item{
            width: 100%;
            .cover{
                padding-bottom: 42.03%;
                border-radius: .1rem;
            }
        }
    }
}
</style>